import styles from './TermsPage.module.scss';

const TermsPage = () => {
  return (
    <div>
      <h1 className={styles.title}>Privacy Policy</h1>
      <ol>
        <li className={styles.item}>
          <p>AIM OF THE PRIVACY POLICY</p>
          <p>
            The Privacy Policy represents an ongoing concern for MARMELAPP and companies affiliated
            to it (mother company, subsidiaries, etc.) (hereinafter referred to as MARMELAPP) in
            ensuring the protection of the private lives of users of the services described
            hereinafter in view of current regulations and in particular, Law 78-17 of January 6,
            1978 relating to information technology, files and freedom. The current Privacy Policy
            is an integral part of the Terms and Conditions of Use governing the games and software
            applications provided by MARMELAPP, in particular via third-party social network
            platforms (hereinafter referred to as “Platforms”), including all content, all services
            and all features accessed via these games and software applications (hereinafter
            referred to collectively as “Services”). In particular, the current Privacy Policy aims
            to inform you of the general policy implemented by MARMELAPP in terms of protecting
            personal data collected and processed as a result of using the Services governed by the
            aforementioned Terms and Conditions of Use.
          </p>

          <p>
            By accessing and/or using the Services, you explicitly accept the terms of this Privacy
            Policy and, as a consequence, agree to the gathering, retaining, using and divulging of
            your personal data, as described herein. You are hereby advised that the Privacy Policy
            can be modified by MARMELAPP at any time. With this in mind, by continuing to use and/or
            access the Services after the last-modified date of any changes, you will be deemed to
            have accepted these changes as modified. You are therefore invited to regularly consult
            the Privacy Policy to ensure you are up-to-date with any potential changes.
          </p>
        </li>

        <li className={styles.item}>
          <p>DATA COLLECTION</p>
          <p>
            Data collected by MARMELAPP via the Platforms The data collected and processed are
            willingly supplied by you to MARMELAPP through the Platforms by agreeing to access and
            use the Services from these Platforms. At a minimum, such data will include your name,
            profile photo, sex, your network(s), username, the user ID numbers of your friends
            and/or people belonging to your network(s) and other information supplied by you to all
            users of the Platforms. If applicable, MARMELAPP is also likely to collect, still via
            the Platforms, any additional data you may agree to supply to it (e.g., your email
            address). As all personal data are supplied directly to MARMELAPP by the Platforms, it
            is deemed that you have read and agreed to the Platforms’ terms and conditions of use
            and their privacy policy. MARMELAPP shall not be held liable for the way in which
            Platforms act in terms of collecting, storing and processing your personal data. In
            addition, you are responsible for the privacy settings of your accounts on the Platforms
            in such a way that MARMELAPP cannot be held liable in this regard.
          </p>

          <p>
            Data collected by MARMELAPP directly Through provision of its Services, MARMELAPP may
            also collect data from you directly. As such, by using certain features within the
            Services which require online payment, you agree that your bank details, email address
            and/or your telephone number may be collected in compliance with current regulations in
            force. Within the context of using its Services and/or related official spaces
            (dedicated official spaces on the Platforms, support website, etc.), MARMELAPP may also
            invite you to participate in promotional events (contests, free sweepstakes, etc.).
            Participation in these promotional events implies your full and complete agreement to
            the collection, storage and processing of any personal data you supply. If applicable,
            and within the context of using the Services, the number of points you collect may be
            retained in order to determine your rank/level with the particular purpose of defining
            player rankings. By using the Services, you agree, in particular, that your score, your
            rank/level, your ID and your photo be listed in the overall player ranking, which all
            users of the Services will be able to view. Furthermore, when you contact MARMELAPP
            directly via its support service, the latter may collect and store your contact data (in
            particular your name, mailing address and email address) and, where applicable, your
            user ID number for the Platforms from where you access and use the Services, as well as
            some information relating to your use of the Services that you will provide to
            MARMELAPP. Finally, MARMELAPP may need to collect aggregate data in order to be able to
            provide an optimized level of Services. This may include data such as your IP address,
            browser type, browser language, number of clicks, pages viewed and also, more generally,
            browsing and connection data.
          </p>
        </li>
      </ol>
    </div>
  );
};

export default TermsPage;
